<template>
	<vue-editor id="editor1" v-model="content" useCustomImageHandler @image-added="handleImageAdded"></vue-editor>
</template>
<script>
  import { VueEditor } from "vue2-editor";
  export default {
    props: {
      content: String,
    },
  	components: {
    	VueEditor
  	},
  	data () {
      return {
        req:{},
	  }
	},
	 methods: {
      handleImageAdded(file, Editor, cursorLocation, resetUploader) {
          var formData = new FormData();
          formData.append("image", file);
          this.req.post(this.$store.getters.["base_api"]+'UploadImageContent',formData)
          .then(result => {
            let url = result.data.url;
              Editor.insertEmbed(cursorLocation, "image", url);
              resetUploader();
            })
            .catch(err => {
              console.log(err);
          });
      },
      GetValue(){
        return this.content;
      },
      ClearValue(){
        this.content = '';
      },
  	},
    mounted() {
      this.req = this.$store.getters.req;
    },
  }
</script>
<style type="text/css">
  .ql-editor {
      min-height: 500px !important;
      height: 500px !important;
  }
</style>